import { isInTelegram } from '../telegram';

// ============================================================================
// Этап W2 (веб-заказы): видимые в DOM кнопки навигации для обычного браузера.
// В Telegram заказ ведётся нативными MainButton/BackButton — их рисует сам
// Telegram поверх веб-вью. В обычном браузере этих кнопок нет (вызовы проходят
// «вхолостую» и ничего не показывают), поэтому для веба нужны собственные
// кнопки в разметке. Эти компоненты НИЧЕГО не рендерят внутри Telegram
// (isInTelegram() === true) — там работают нативные кнопки.
// ============================================================================

// Нижняя «плавающая» кнопка действия — веб-замена Telegram MainButton.
// Фиксируется внизу экрана; контент страниц уже имеет нижний отступ (~80px),
// чтобы кнопка ничего не перекрывала.
export function WebActionBar({
  label,
  onClick,
  disabled,
  variant = 'primary',
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'muted';
}) {
  if (isInTelegram()) return null;
  const muted = variant === 'muted' || disabled;
  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        padding: '12px 16px calc(12px + env(safe-area-inset-bottom, 0px))',
        background: 'var(--tg-bg)',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        zIndex: 50,
      }}
    >
      <button
        onClick={onClick}
        disabled={disabled}
        style={{
          display: 'block',
          width: '100%',
          maxWidth: 560,
          margin: '0 auto',
          padding: '14px 0',
          border: 'none',
          borderRadius: 12,
          background: muted ? 'var(--tg-secondary-bg)' : 'var(--tg-button)',
          color: muted ? 'var(--tg-hint)' : 'var(--tg-button-text, #fff)',
          fontSize: 15,
          fontWeight: 700,
          fontFamily: 'inherit',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {label}
      </button>
    </div>
  );
}

// Верхняя кнопка «назад» — веб-замена Telegram BackButton.
export function WebBackButton({ onClick, label = '‹ Назад' }: { onClick: () => void; label?: string }) {
  if (isInTelegram()) return null;
  return (
    <button
      onClick={onClick}
      style={{
        background: 'transparent',
        border: 'none',
        color: 'var(--tg-button)',
        fontSize: 15,
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: 'pointer',
        padding: '4px 0',
        marginBottom: 12,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      {label}
    </button>
  );
}
